import type { FC } from 'react';
import React from 'react';
import type { FormControlProps } from '@mui/material';
import { FormControl, Typography } from '@mui/material';

interface FollowUpInputProps extends FormControlProps {
  label: string;
  disabled?: boolean;
  name: string;
  errorMessage?: string | string[] | false;
  helperText?: string;
}

const FollowUpInput: FC<FollowUpInputProps> = ({
  label,
  disabled = false,
  name,
  errorMessage,
  helperText,
  children,
  ...props
}) => (
  <FormControl {...props} disabled={disabled}>
    <Typography component="label" htmlFor={name}>
      {label}
    </Typography>
    {helperText && <Typography variant="body4">{helperText}</Typography>}
    {children}
    {errorMessage && (
      <Typography variant="body4" color="error">
        {errorMessage}
      </Typography>
    )}
  </FormControl>
);

export default FollowUpInput;
